import { render, staticRenderFns } from "./healthQuotient.vue?vue&type=template&id=560432ec&scoped=true"
import script from "./healthQuotient.vue?vue&type=script&lang=js"
export * from "./healthQuotient.vue?vue&type=script&lang=js"
import style0 from "./healthQuotient.vue?vue&type=style&index=0&id=560432ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560432ec",
  null
  
)

export default component.exports